import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style", "css", "direction", "color", "size", "spacing", "isFirstItem", "indentContent"];
import React from "react";
import { BaseDivider } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Divider(_ref) {
  var as = _ref.as,
    style = _ref.style,
    css = _ref.css,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "horizontal" : _ref$direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "neutral" : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "sm" : _ref$size,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? "none" : _ref$spacing,
    isFirstItem = _ref.isFirstItem,
    indentContent = _ref.indentContent,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseDivider, _extends({
    direction: direction,
    color: color,
    size: size,
    spacing: spacing
  }, restProps));
}
export default Divider;